import { PayloadAction } from '@reduxjs/toolkit';

import { ReturnToHospitalClient, ReturnToHospitalSummaryDto } from '@medone/medonehp-api-client';

import { handleError } from '../../../../shared/common/HandleErrors';
import { shouldSkipByPatientId } from '../../../../shared/common/helpers';
import { Axios } from '../../../../shared/common/http';
import { AppDispatch, AppThunk, RootState } from '../../../../shared/store';
import { CensusState } from './models';
import { censusSlice } from './slice';

export const reducers = {
    setReturnToHospitals: (state: CensusState, action: PayloadAction<ReturnToHospitalSummaryDto[]>) => {
        state.returnToHospitals = action.payload;
    },
};

export function fetchReturnToHospitalsByPatientId(patientId: number): AppThunk {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        const client = new ReturnToHospitalClient(null, Axios);

        try {
            const response = await client.getByPatientId(patientId);

            // Guard against race condition: discard if user navigated to a different patient
            if (shouldSkipByPatientId(getState().census, patientId)) {
                return;
            }

            if (!response.result.succeeded) {
                handleError(response);
            } else {
                dispatch(censusSlice.actions.setReturnToHospitals(response.result.entity));
            }
        } catch (error) {
            handleError(error);
        }
    };
}

export const selectReturnToHospitals = (state: RootState) => state.census.returnToHospitals;
